module.exports = (__webpack_require__(/*! dll-reference dll_b919ee6c3f90c44aab90 */ "dll-reference dll_b919ee6c3f90c44aab90"))("./node_modules/react/index.js");